//core
import { createSelector } from "@reduxjs/toolkit";

//store
import { RootState } from "../../index";

// state
const listSelector = (state: RootState) => state.admin.flatFee.list;
const listDataSelector = (state: RootState) => state.admin.flatFee.list.data;
const listErrorSelector = (state: RootState) => state.admin.flatFee.list.error;
const listFetchingSelector = (state: RootState) => state.admin.flatFee.list.isFetching;

//selectors
export const selectList = createSelector(listSelector, (list) => list);
export const selectListData = createSelector(listDataSelector, (data) => {
  if (!!data) {
    const columns = data.columns.map((item: any) => {
      if (item.name === 'description') {
        return { ...item, type: 'mediumString' };
      }
			if (item.name === 'status') {
        return { ...item, type: 'status' };
      }
			if (item.name === 'amount') {
        return { ...item, type: 'flatFeeAmount' };
      }
			if (item.name === 'affiliate_id') {
        return { ...item, type: 'clickableUserId' };
      }
			if (item.name === 'tracker_id') {
        return { ...item, type: 'string' };
      }
			if (item.name === 'target_date') {
        return { ...item, type: 'datetime' };
      }
			if (item.name === 'id') {
        return { ...item, type: 'string' };
      }

      return item;
    });

    return {
      ...data,
      columns: [
        ...columns
      ],
    };
  } else {
    return data;
  }
});
export const selectListDataColumnsSort = createSelector(listDataSelector, (data) => {
  return data?.columns.filter((el: any) => el.sort === true)
});
export const selectListError = createSelector(listErrorSelector, (error) => error);
export const selectListIsFetching = createSelector(listFetchingSelector, (isFetching) => isFetching);

//Delete Flat Fee
const deleteFlatFeeDataSelector = (state: RootState) => state.admin.flatFee.deleteFlatFee.data;
const deleteFlatFeeErrorSelector = (state: RootState) => state.admin.flatFee.deleteFlatFee.error;
const deleteFlatFeeFetchingSelector = (state: RootState) => state.admin.flatFee.deleteFlatFee.isFetching;

export const selectDeleteData = createSelector(deleteFlatFeeDataSelector, (data) => data);
export const selectDeleteError = createSelector(deleteFlatFeeErrorSelector, (error) => error);
export const selectDeleteIsFetching = createSelector(deleteFlatFeeFetchingSelector, (isFetching) => isFetching);

//Create Flat Fee
const createFlatFeeDataSelector = (state: RootState) => state.admin.flatFee.createFlatFee.data;
const createFlatFeeErrorSelector = (state: RootState) => state.admin.flatFee.createFlatFee.error;
const createFlatFeeFetchingSelector = (state: RootState) => state.admin.flatFee.createFlatFee.isFetching;

export const selectCreateData = createSelector(createFlatFeeDataSelector, (data) => data);
export const selectCreateError = createSelector(createFlatFeeErrorSelector, (error) => error);
export const selectCreateIsFetching = createSelector(createFlatFeeFetchingSelector, (isFetching) => isFetching);

//Update Flat Fee
const updateFlatFeeDataSelector = (state: RootState) => state.admin.flatFee.updateFlatFee.data;
const updateFlatFeeErrorSelector = (state: RootState) => state.admin.flatFee.updateFlatFee.error;
const updateFlatFeeFetchingSelector = (state: RootState) => state.admin.flatFee.updateFlatFee.isFetching;

export const selectUpdateData = createSelector(updateFlatFeeDataSelector, (data) => data);
export const selectUpdateError = createSelector(updateFlatFeeErrorSelector, (error) => error);
export const selectUpdateIsFetching = createSelector(updateFlatFeeFetchingSelector, (isFetching) => isFetching);

//Download Flat Fee
const downloadFlatFeeDataSelector = (state: RootState) => state.admin.flatFee.download.data;
const downloadFlatFeeErrorSelector = (state: RootState) => state.admin.flatFee.download.error;
const downloadFlatFeeFetchingSelector = (state: RootState) => state.admin.flatFee.download.isFetching;

export const selectDownloadData = createSelector(downloadFlatFeeDataSelector, (data) => data);
export const selectDownloadError = createSelector(downloadFlatFeeErrorSelector, (error) => error);
export const selectDownloadIsFetching = createSelector(downloadFlatFeeFetchingSelector, (isFetching) => isFetching);